import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Anim from './Anim';

import html from "../assets/skills/html.png";
import typescript from "../assets/skills/typescript.png";
import css from "../assets/skills/css.png";
import javascript from "../assets/skills/javascript.png";
import react from "../assets/skills/react.png";
import redux from "../assets/skills/redux.png";
import tailwind from "../assets/skills/tailwind.png";
import nextjs from "../assets/skills/nextjs.png";

import node from "../assets/skills/node.png";
import express from "../assets/skills/exp.png";
import mongo from "../assets/skills/mongo.png";
import firebase from "../assets/skills/fireb.png";

import aws from "../assets/skills/aws.png";
import nginx from "../assets/skills/nginx.png";
import vercel from "../assets/skills/vercel.png";
import netlify from "../assets/skills/netlify.png";
import render from "../assets/skills/render.png";

import git from "../assets/skills/git.png";
import github from "../assets/skills/github.png";

const Experience = () => {
  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  const categories = [
    {
      title: "Frontend",
      skills: [
        { id: 5, src: react, title: "React", style: "shadow-sky-400" },
        { id: 6, src: nextjs, title: "Next.js", style: "shadow-white" },
        { id: 4, src: typescript, title: "TypeScript", style: "shadow-blue-500" },
        { id: 3, src: javascript, title: "JavaScript", style: "shadow-yellow-500" },
        { id: 1, src: html, title: "HTML", style: "shadow-orange-500" },
        { id: 2, src: css, title: "CSS", style: "shadow-blue-500" },
        { id: 8, src: tailwind, title: "Tailwind CSS", style: "shadow-sky-400" },
        { id: 7, src: redux, title: "Redux", style: "shadow-purple-400" },
      ],
    },
    {
      title: "Backend & DB",
      skills: [
        { id: 9, src: node, title: "Node.js", style: "shadow-green-500" },
        { id: 10, src: express, title: "Express.js", style: "shadow-white" },
        { id: 11, src: mongo, title: "MongoDB", style: "shadow-green-400" },
        { id: 12, src: firebase, title: "Firebase", style: "shadow-yellow-700" },
      ],
    },
    {
      title: "Hosting & Deployment",
      skills: [
        { id: 13, src: aws, title: "AWS", style: "shadow-white" },
        { id: 14, src: nginx, title: "Nginx", style: "shadow-green-500" },
        { id: 15, src: vercel, title: "Vercel", style: "shadow-white" },
        { id: 17, src: render, title: "Render", style: "shadow-white" },
        { id: 16, src: netlify, title: "Netlify", style: "shadow-sky-400" },
      ],
    },
    {
      title: "Tools",
      skills: [
        { id: 18, src: git, title: "Git", style: "shadow-red-500" },
        { id: 19, src: github, title: "GitHub", style: "shadow-white" },
      ],
    },
  ];

  return (
    <section
      id="skills"
      ref={ref}
      className="bg-black min-h-screen py-20 px-6 md:px-16 lg:px-24 "
    >
      <div className="max-w-6xl mx-auto px-4 ">
        <div className="text-center mb-5 ">
          <h2 className='md:text-center text-4xl font-bold  text-white flex justify-center '>
            <span className='border-b-4 border-gray-500 mb-2'> Skills</span></h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-lg">
            Technologies and tools I use to design, develop and deploy applications.
          </p>
        </div>

        <div className='mt-14 md:-mt-24'> <Anim /></div>

        <div className="space-y-12">
          {categories.map((category, catIndex) => (
            <motion.div
              key={category.title}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: catIndex * 0.12 }}
            >
              <h3 className="text-2xl my-8 text-[#F16A6A] mb-6 text-center">
                {category.title}
              </h3>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-10  gap-y-6">
                {category.skills.map(({ id, src, title, style }) => (
                  <motion.div
                    key={id}
                    className={`shadow-md transform py-4 rounded-lg flex flex-col items-center justify-center bg-gradient-to-b from-[#0f0f0f] to-[#070707] border border-gray-800 ${style}`}
                    initial={{ opacity: 0, x: -500 }}
                    animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -500 }}
                    transition={{ duration: 0.8, delay: id * 0.08 }} 
                    whileHover={{ scale: 1.08, transition: { duration: 0.2 } }}
                  >
                    <img src={src} alt={`${title} Technology Logo`} className="w-14 h-14 mx-auto" />
                    <p className="text-white mt-4 text-sm md:text-base font-semibold">
                      {title}
                    </p>
                  </motion.div>

                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
